import React from "react";
import Grid from "@mui/material/Grid";
import { formatMoney } from "../MoneyField";

export const GridSummary = ({ data = [], sum = [], sx = {}, ...rest }) => {
  const accum = data.reduce((prev, next) => {
    const result = {};

    sum.forEach(key => {
      result[key] = (prev[key] || 0) + next[key];
    });

    return result;
  }, {});

  return (
    <Grid
      container
      justifyContent="flex-end"
      sx={{
        bgcolor: "grey.200",
        borderRight: "1px solid #ccc",
        borderBottom: "1px solid #ccc",
      }}
    >
      {Object.keys(accum).map(key => (
        <Grid
          key={key}
          item
          sx={{
            padding: 1,
            textAlign: "right",
            ...sx,
          }}
          {...rest}
        >
          {formatMoney(accum[key])}
        </Grid>
      ))}
    </Grid>
  );
}
